import { render } from "./UiTextArea.vue?vue&type=template&id=1d6c8d72&ts=true"
import script from "./UiTextArea.vue?vue&type=script&lang=ts"
export * from "./UiTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__